import { createWebRegistration } from '@reflex/plugin-api/create-web-registration';
import { LinearIcon } from './LinearIcon';

export default createWebRegistration({
  authProviders: {
    linear: {
      icon: LinearIcon,
      benefit: 'Enables issue tracking and agent-driven task management',
    },
  },
});
